/**
 * Theme Definitions
 *
 * Light and dark theme color palettes.
 * Used by ThemeContext to provide theme-aware colors.
 */

export const lightTheme = {
  name: 'light',
  colors: {
    background: 'hsl(0deg 0% 97%)',
    backgroundPanel: 'hsl(0deg 0% 100%)',
    backgroundOffset: 'hsl(0deg 0% 93%)',
    foreground: 'hsl(0deg 0% 9%)',
    foregroundSecondary: 'hsl(240deg 1% 44%)',
    foregroundTertiary: 'hsl(240deg 2% 78%)',
    border: 'hsl(0deg 0% 91%)',
    borderLight: 'hsl(0deg 0% 88%)',
  }
};

export const darkTheme = {
  name: 'dark',
  colors: {
    background: 'hsl(0deg 0% 9%)',
    backgroundPanel: 'hsl(0deg 0% 13%)',
    backgroundOffset: 'hsl(0deg 0% 17%)',
    foreground: 'hsl(0deg 0% 97%)',
    foregroundSecondary: 'hsl(240deg 1% 60%)',
    foregroundTertiary: 'hsl(240deg 2% 35%)',
    border: 'hsl(0deg 0% 20%)',
    borderLight: 'hsl(0deg 0% 25%)',
  }
};

export const themes = {
  light: lightTheme,
  dark: darkTheme
};
